import ReduxHooks from '../../../store/ReduxHooks';
import { actionCreators } from '../../../store/actions';
import ApiResourceManager from '../ApiResourceManager';

export default class CurrentCompanyManager extends ApiResourceManager {
  get = async () => {
    const response = await this.request({
      method: 'GET',
      url: '/current-company',
    });

    if (response.success) {
      ReduxHooks.batchActions([
        actionCreators.currentCompany.set(response.data),
        actionCreators.currentServiceProvider.set(response.data.service_provider),
      ]);
    }

    return response;
  };

  getSummary = () =>
    this.request({
      method: 'GET',
      url: '/current-company/summary',
    });

  exportMenu = async () =>
    this.request({
      method: 'GET',
      url: '/current-company/export-menu',
      responseType: 'blob',
    });

  getTopItems = (params) =>
    this.request({
      method: 'GET',
      url: '/current-company/top-items',
      params,
    });
}
